import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { reviews } from '../data/reviews';
import { Pill } from './ui/Pill';
import { OrigenChip } from './origen/OrigenChip';
import { waLink } from '../utils/whatsapp';
function GoogleMark() {
  return <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" className="h-3 w-3" data-id="element-240" data-mp="2mady07bbcizy">
      <path fill="#4285F4" d="M21.6 12.2c0-.7-.1-1.4-.2-2H12v3.8h5.4a4.6 4.6 0 0 1-2 3v2.5h3.2c1.9-1.7 3-4.3 3-7.3z" data-id="element-241" data-mp="2rccx3500str3" />
      <path fill="#4285F4" d="M12 22c2.7 0 4.9-.9 6.6-2.4l-3.2-2.5c-.9.6-2 1-3.4 1a5.9 5.9 0 0 1-5.6-4.1H3.1v2.6A10 10 0 0 0 12 22zM6.4 14a6 6 0 0 1 0-3.9V7.5H3.1a10 10 0 0 0 0 9zM12 5.9c1.5 0 2.8.5 3.8 1.5l2.8-2.8A10 10 0 0 0 3.1 7.5l3.3 2.6A5.9 5.9 0 0 1 12 5.9z" opacity="0.85" data-id="element-242" data-mp="30b86epyd2jym" />
    </svg>;
}
export function Reviews() {
  return <section id="resenas" className="bg-white py-12 lg:py-20" aria-labelledby="resenas-title" data-id="element-243" data-mp="3f278di4oya98">
      <div className="mx-auto max-w-[1100px] px-5" data-id="element-244" data-mp="3jzpaaokajp7q">
        <header data-id="element-245" data-mp="2rcxidayhf9wq">
          <Pill data-id="element-246" data-mp="2rdp5dxe0jzbe">Lo que dicen los pacientes</Pill>
          <h2 id="resenas-title" className="mt-5 max-w-[600px] font-display text-[26px] font-bold leading-[1.2] text-ink lg:text-[36px]" data-id="element-247" data-mp="2rab2mo1fto3f">
            La confianza se construye con cada experiencia real.
          </h2>
          <p className="mt-4 max-w-[560px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-248" data-mp="2de7k3rzxf46s">
            Las opiniones más valiosas son las que los pacientes escriben por iniciativa propia.
          </p>
          <p className="mt-3 inline-block rounded-lg border border-[#F59E0B] bg-[#FEF9EC] px-[14px] py-2 font-sans text-[12px] text-[#92400E]" data-id="element-249" data-mp="355dcfm9enxli">
            Diseño demostrativo · Las reseñas reales van aquí con fuente verificable
          </p>
          <OrigenChip layout="flow" order={5} arrow="bottom" className="ml-0 mr-auto mt-5" data-id="element-250" data-mp="3stmtybzl5z6u">
            Las reseñas son el factor de confianza más consultado por pacientes nuevos antes de elegir un consultorio.
            Esta sección muestra la estructura ideal: texto auténtico, nombre, fecha y fuente verificable. En una página
            real, se conecta directamente con Google Reviews.
          </OrigenChip>
        </header>

        <ul className="mt-10 grid grid-cols-1 gap-5 lg:grid-cols-3" data-id="element-251" data-mp="1cgcpf83zxy0h">
          {reviews.map(review => <li key={review.id} className="relative flex flex-col rounded-2xl border border-hairline bg-base p-7 shadow-[0_2px_8px_rgba(0,0,0,0.05)]" data-id="element-252" data-mp="1hdme2ljka5n9">
              <span className="absolute right-3 top-3 rounded-pill border border-secondary/25 bg-secondary/10 px-2 py-[3px] font-sans text-[10px] font-medium text-secondary" data-id="element-253" data-mp="18f0x2utqmyol">
                ejemplo
              </span>
              <p className="text-[18px] leading-none text-[#F59E0B]" aria-label="Cinco estrellas de cinco" data-id="element-254" data-mp="ygbpbuvk2um2">
                ★★★★★
              </p>
              <blockquote className="mt-3 font-sans text-[15px] italic leading-[1.7] text-[#374151]" data-id="element-255" data-mp="2stkqmzdy79t8">
                «{review.text}»
              </blockquote>
              <hr className="my-5 border-hairline" data-id="element-256" data-mp="h6r0bhu06yaa" />
              <div className="mt-auto flex items-center gap-3" data-id="element-257" data-mp="c7wgqdo7p5p4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full font-sans text-[16px] font-bold text-white" style={{
              backgroundColor: review.avatarColor
            }} aria-hidden="true" data-id="element-258" data-mp="c5jqld8avp0z">
                  {review.initials}
                </span>
                <span className="min-w-0" data-id="element-259" data-mp="vw5ags5eljqq">
                  <span className="block font-sans text-[14px] font-semibold text-ink" data-id="element-260" data-mp="vv3v4bhcub37">{review.name}</span>
                  <span className="mt-[2px] flex items-center gap-1 font-sans text-[11px] text-[#9CA3AF]" data-id="element-261" data-mp="19t28penuq3hn">
                    <GoogleMark data-id="element-262" data-mp="14u8x5rs4kmk4" />
                    Google Reviews
                  </span>
                </span>
              </div>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-263" data-mp="36p9hkc2pdgbw">
          <p className="font-sans text-[24px] font-bold text-[#F59E0B]" data-id="element-264" data-mp="384ua8oqar07s">★★★★★ 4.9</p>
          <p className="mt-1 font-sans text-[14px] text-[#9CA3AF]" data-id="element-265" data-mp="3d3ottsw38ssy">Basado en reseñas de Google</p>
          <p className="mt-2 font-sans text-[12px] italic text-[#9CA3AF]" data-id="element-266" data-mp="3i2rz9efzd11g">
            Ejemplo demostrativo · En tu página irían tus reseñas reales y verificables
          </p>

          <p className="mt-8 font-sans text-[15px] text-muted" data-id="element-267" data-mp="3mzs63rknm7tm">¿Quieres compartir tu experiencia?</p>
          <a href={waLink('Hola, vi la demo de Sonrisa Clara y me interesa algo así para mi consultorio.')} target="_blank" rel="noreferrer" className="mt-1 inline-flex items-center gap-1 text-center font-sans text-[14px] font-medium text-secondary transition-colors hover:text-[#2f9a95]" data-id="element-268" data-mp="2pbzwfy4ete55">
            ¿Quieres una presencia así para tu consultorio? Escríbenos
            <ArrowRightIcon className="h-4 w-4" data-id="element-269" data-mp="2bmpnys2wpa7c" />
          </a>
        </div>
      </div>
    </section>;
}